<template>
  <div>
    <div class="flex flex-col justify-center items-center">
      <h2 class="py-5 text-2xl font-semibold w-5/12 text-center mt-5">Confirm and Pay</h2>
      <p class="py-6 lato text-gray-700 text-sm">You’re booking an appointment with</p>
      <img src="@/assets/img/physician1.svg" alt="" class="rounded-full w-16 h-16">
      <p class="font-semibold py-1 text-mainblack lato">Jason Whooper, MD</p>
      <p class="text-sm text-secondary">Cardiologist</p>
    </div>
    <div class="grid grid-cols-2 gap-10 w-4/12 my-6 m-auto">
      <div class="flex">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.6666 2.66671H11.3333V2.00004C11.3333 1.82323 11.263 1.65366 11.138 1.52864C11.013 1.40361 10.8434 1.33337 10.6666 1.33337C10.4898 1.33337 10.3202 1.40361 10.1952 1.52864C10.0702 1.65366 9.99992 1.82323 9.99992 2.00004V2.66671H5.99992V2.00004C5.99992 1.82323 5.92968 1.65366 5.80466 1.52864C5.67963 1.40361 5.51006 1.33337 5.33325 1.33337C5.15644 1.33337 4.98687 1.40361 4.86185 1.52864C4.73682 1.65366 4.66659 1.82323 4.66659 2.00004V2.66671H3.33325C2.80282 2.66671 2.29411 2.87742 1.91904 3.25249C1.54397 3.62757 1.33325 4.13627 1.33325 4.66671V12.6667C1.33325 13.1971 1.54397 13.7058 1.91904 14.0809C2.29411 14.456 2.80282 14.6667 3.33325 14.6667H12.6666C13.197 14.6667 13.7057 14.456 14.0808 14.0809C14.4559 13.7058 14.6666 13.1971 14.6666 12.6667V4.66671C14.6666 4.13627 14.4559 3.62757 14.0808 3.25249C13.7057 2.87742 13.197 2.66671 12.6666 2.66671ZM13.3333 12.6667C13.3333 12.8435 13.263 13.0131 13.138 13.1381C13.013 13.2631 12.8434 13.3334 12.6666 13.3334H3.33325C3.15644 13.3334 2.98687 13.2631 2.86185 13.1381C2.73682 13.0131 2.66659 12.8435 2.66659 12.6667V8.00004H13.3333V12.6667ZM13.3333 6.66671H2.66659V4.66671C2.66659 4.4899 2.73682 4.32033 2.86185 4.1953C2.98687 4.07028 3.15644 4.00004 3.33325 4.00004H4.66659V4.66671C4.66659 4.84352 4.73682 5.01309 4.86185 5.13811C4.98687 5.26314 5.15644 5.33337 5.33325 5.33337C5.51006 5.33337 5.67963 5.26314 5.80466 5.13811C5.92968 5.01309 5.99992 4.84352 5.99992 4.66671V4.00004H9.99992V4.66671C9.99992 4.84352 10.0702 5.01309 10.1952 5.13811C10.3202 5.26314 10.4898 5.33337 10.6666 5.33337C10.8434 5.33337 11.013 5.26314 11.138 5.13811C11.263 5.01309 11.3333 4.84352 11.3333 4.66671V4.00004H12.6666C12.8434 4.00004 13.013 4.07028 13.138 4.1953C13.263 4.32033 13.3333 4.4899 13.3333 4.66671V6.66671Z" fill="#292929"/>
        </svg>
        <span class="-mt-0.5 pl-1">Date &amp; time</span>
      </div>
      <div class="flex flex-col text-right lato">
         <div>
          <p class="">Sunday, March 11, 2022</p>
          <p class="text-maingrey">9:00 am - 9:50 am</p>
          <p class="text-maingrey">12:15 pm - 1:45 pm</p>
        </div>
        <div class="my-4">
          <p class="">Sunday, March 12, 2022</p>
          <p class="text-maingrey">9:00 am - 9:50 am</p>
        </div>
        <div>
          <p class="">Monday, March 12, 2022</p>
          <p class="text-maingrey">9:00 am - 9:30 am</p>
          <p class="text-maingrey">12:15 pm - 1:45 pm</p>
          <p class="text-maingrey">3:00 pm - 4:00 pm</p>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-2 gap-10 w-4/12 mt-24 m-auto">
      <div class="flex">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.33326 7H7.99992C8.17673 7 8.3463 6.92977 8.47133 6.80474C8.59635 6.67972 8.66659 6.51015 8.66659 6.33334C8.66659 6.15653 8.59635 5.98696 8.47133 5.86193C8.3463 5.73691 8.17673 5.66667 7.99992 5.66667H7.33326V5.33334C7.33326 5.15653 7.26302 4.98696 7.13799 4.86193C7.01297 4.73691 6.8434 4.66667 6.66659 4.66667C6.48978 4.66667 6.32021 4.73691 6.19519 4.86193C6.07016 4.98696 5.99992 5.15653 5.99992 5.33334V5.7C5.59487 5.78225 5.23483 6.01207 4.9897 6.34485C4.74456 6.67762 4.63182 7.08961 4.67335 7.50084C4.71489 7.91206 4.90775 8.29318 5.21448 8.57021C5.52121 8.84724 5.91994 9.00042 6.33326 9H6.99992C7.08833 9 7.17311 9.03512 7.23563 9.09764C7.29814 9.16015 7.33326 9.24493 7.33326 9.33334C7.33326 9.42174 7.29814 9.50653 7.23563 9.56904C7.17311 9.63155 7.08833 9.66667 6.99992 9.66667H5.33326C5.15645 9.66667 4.98688 9.73691 4.86185 9.86193C4.73683 9.98696 4.66659 10.1565 4.66659 10.3333C4.66659 10.5101 4.73683 10.6797 4.86185 10.8047C4.98688 10.9298 5.15645 11 5.33326 11H5.99992V11.3333C5.99992 11.5101 6.07016 11.6797 6.19519 11.8047C6.32021 11.9298 6.48978 12 6.66659 12C6.8434 12 7.01297 11.9298 7.13799 11.8047C7.26302 11.6797 7.33326 11.5101 7.33326 11.3333V10.9667C7.73831 10.8844 8.09835 10.6546 8.34349 10.3218C8.58862 9.98905 8.70137 9.57706 8.65983 9.16584C8.61829 8.75461 8.42543 8.37349 8.1187 8.09646C7.81197 7.81943 7.41324 7.66626 6.99992 7.66667H6.33326C6.24485 7.66667 6.16007 7.63155 6.09756 7.56904C6.03504 7.50653 5.99992 7.42174 5.99992 7.33334C5.99992 7.24493 6.03504 7.16015 6.09756 7.09764C6.16007 7.03512 6.24485 7 6.33326 7ZM13.9999 8H11.9999V2C12.0004 1.88253 11.9698 1.76702 11.9113 1.66517C11.8527 1.56332 11.7683 1.47874 11.6666 1.42C11.5652 1.36149 11.4503 1.33069 11.3333 1.33069C11.2162 1.33069 11.1013 1.36149 10.9999 1.42L8.99992 2.56667L6.99992 1.42C6.89858 1.36149 6.78362 1.33069 6.66659 1.33069C6.54957 1.33069 6.4346 1.36149 6.33326 1.42L4.33326 2.56667L2.33326 1.42C2.23191 1.36149 2.11695 1.33069 1.99992 1.33069C1.8829 1.33069 1.76794 1.36149 1.66659 1.42C1.56485 1.47874 1.48044 1.56332 1.42191 1.66517C1.36337 1.76702 1.33279 1.88253 1.33326 2V12.6667C1.33326 13.1971 1.54397 13.7058 1.91904 14.0809C2.29412 14.456 2.80282 14.6667 3.33326 14.6667H12.6666C13.197 14.6667 13.7057 14.456 14.0808 14.0809C14.4559 13.7058 14.6666 13.1971 14.6666 12.6667V8.66667C14.6666 8.48986 14.5964 8.32029 14.4713 8.19527C14.3463 8.07024 14.1767 8 13.9999 8ZM3.33326 13.3333C3.15645 13.3333 2.98688 13.2631 2.86185 13.1381C2.73683 13.0131 2.66659 12.8435 2.66659 12.6667V3.15334L3.99992 3.91334C4.10282 3.96708 4.21718 3.99515 4.33326 3.99515C4.44934 3.99515 4.5637 3.96708 4.66659 3.91334L6.66659 2.76667L8.66659 3.91334C8.76948 3.96708 8.88384 3.99515 8.99992 3.99515C9.11601 3.99515 9.23037 3.96708 9.33326 3.91334L10.6666 3.15334V12.6667C10.6684 12.8941 10.709 13.1196 10.7866 13.3333H3.33326ZM13.3333 12.6667C13.3333 12.8435 13.263 13.0131 13.138 13.1381C13.013 13.2631 12.8434 13.3333 12.6666 13.3333C12.4898 13.3333 12.3202 13.2631 12.1952 13.1381C12.0702 13.0131 11.9999 12.8435 11.9999 12.6667V9.33334H13.3333V12.6667Z" fill="#292929"/>
        </svg>
        <p class="-mt-0.5 font-semibold pl-1">Fee</p>
      </div>
      <p class="text-right">$154.00/hr</p>
    </div>
    <div class="w-4/12 my-10 m-auto">
      <p class="text-secondary pb-3">Card Number</p>
      <el-input
        type="number"
        v-model.number="card_number"
        placeholder="0000 0000 0000 0000"
      ></el-input>
      <div class="flex justify-between items-center my-4">
        <div>
          <p class="text-secondary pb-3">Expiry date</p>
          <el-input v-model="expiry_date" placeholder="MM/YY" style="width: 14.5rem;"></el-input>
        </div>
        <div>
          <p class="text-secondary pb-3">CVV</p>
          <el-input v-model="cvv" placeholder="123" style="width: 14.5rem;"></el-input>
        </div>
      </div>
      <div class="flex justify-between items-center mt-12">
          <button @click.prevent="back" class="flex items-center">
            <span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12L6 8L10 4" stroke="#292929" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <span>Back</span>
          </button>
           <button
        class="bg-primary rounded-full text-white
        font-semibold py-4 px-16
        focus:outline-none"
        @click="next"
      >Pay $224.00</button>
    </div>
        </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      card_number: '',
      expiry_date: '',
      cvv: ''
    }
  },
  methods: {
    next() {
      this.$emit('handleNext')
    },
    back() {
      this.$emit('handleBack')
    },
  }
}
</script>

<style scoped>
* >>> .el-input__inner {
  background: #EEEEEE !important;
  outline: 0;
  border: none !important;
}
</style>